import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useContentDetails } from '../hooks/useContent';
import { ContentDetails } from '../types';
import MockPlayer from '../components/MockPlayer';

const PlayerPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: content, isLoading, error } = useContentDetails(id || '') as { 
    data: ContentDetails | undefined; 
    isLoading: boolean; 
    error: any; 
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl">Loading title...</div>
      </div>
    );
  }

  if (error || !content || !content.id) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-400 text-xl mb-4">Content not found</div>
          <button onClick={handleBackClick} className="btn-primary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <MockPlayer content={content} onBack={handleBackClick} />;
};

export default PlayerPage;